<script lang="ts">
    import { onDestroy } from 'svelte'

    import { tmpTokenMax, tmpTokenRem } from 'wdom/services/stream'

    interface Props {
        color?: string
        bgColor?: string
        borderColor?: string
    }

    let { color = 'var(--bs-link-color)', bgColor = 'var(--bs-body-bg)', borderColor = 'var(--bs-secondary)' }: Props = $props()

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    let cpStyle = $state('')
    let cpClass = $state('')
    unsubs.push(
        tmpTokenRem.subscribe(($tmpTokenRem) => {
            if (!$tmpTokenRem) {
                cpStyle = ''
                cpClass = ''
                return
            }

            const end = 360 * (1 - $tmpTokenRem / $tmpTokenMax)
            const colour = end >= 270 ? 'var(--bs-danger)' : end >= 180 ? 'var(--bs-warning)' : borderColor
            cpStyle = `background: conic-gradient(var(--bs-card-bg) ${end}deg, ${colour} 0deg);`
        }),
    )
</script>

<style>
    .c-progress-container {
        display: inline-block;
        vertical-align: center;
        --tokprog-outer-w: 1.1454753723em;
        --tokprog-outer-diff: 2px;
        --tokprog-font-size: 0.5727376862em;
        /* --tokprog-outer-w: 1rem;
        --tokprog-outer-diff: 4px;
        --tokprog-font-size: 0.5rem; */
    }
    .circular-progress {
        width: var(--tokprog-outer-w);
        height: var(--tokprog-outer-w);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .inner-circle {
        position: absolute;
        border-radius: 50%;
        width: calc(var(--tokprog-outer-w) - var(--tokprog-outer-diff));
        height: calc(var(--tokprog-outer-w) - var(--tokprog-outer-diff));
    }
    .remaining {
        position: relative;
        font-size: var(--tokprog-font-size);
    }
</style>

<span class="c-progress-container">
    <span class="circular-progress" style={cpStyle}>
        <span class="inner-circle" style={`background-color: ${bgColor}`}></span>
        <span class="remaining" style={`color: ${color}`}>{$tmpTokenRem}</span>
    </span>
</span>
